// @flow

import ApiObject from './ApiObject';

import DateUtils from '../utils/DateUtils';

export default class Payin extends ApiObject {

  amount: number = 0;

  checkId: string = '';

  date: number = 0; // TODO: replace by date object.

  fees: number = 0;

  tips: number = 0;

  userCheckId: string = '';

  waiterName: string = '';

  totalTable: number = 0;

  getFormattedDate(format: string = 'DD/MM/Y'): string {
    return DateUtils.fromSecondsTimestampToString(this.date, format);
  }

  getFormattedHour(format: string = 'HH:mm'): string {
    return DateUtils.fromSecondsTimestampToString(this.date, format);
  }

  postJsonAssignation(data: Object) {
    this.date = Math.floor(this.date / 1000);
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/Payin.js